export function errorNotify(error, notify) {
  let data = error["response"]["data"];

  if (data && data.errors && data.errors.length) {
    let k = 0;
    Object.keys(data.errors).forEach((item) => {
      let err = data.errors[item];
      k++;
      for (let i = 0; i < err.length; i++) {
        setTimeout(() => {
          notify({
            title: "!!!",
            message: err[i],
            icon: "ti-alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "warning",
          });
        }, 100 * k);
      }
    });
  }
  else if (data && data.data) {
    let k = 0;
    Object.keys(data.data).forEach((item) => {
      let err = data.data[item];
      k++;
      for (let i = 0; i < err.length; i++) {
        setTimeout(() => {
          notify({
            title: "!!!",
            message: err[i],
            icon: "ti-alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "warning",
          });
        }, 100 * k);
      }
    });
  }

  else if (data.message) {
    notify({
      title: "!!!",
      message: data.message,
      icon: "ti-alert",
      horizontalAlign: "right",
      verticalAlign: "top",
      type: "warning",
    });
  }
  else if (data.Message) {
    notify({
      title: "!!!",
      message: data.Message,
      icon: "ti-alert",
      horizontalAlign: "right",
      verticalAlign: "top",
      type: "warning",
    });
  }
  else {
    notify({
      title: "!!!",
      message: "ACCESS ERROR",
      icon: "ti-alert",
      horizontalAlign: "right",
      verticalAlign: "top",
      type: "warning",
    });
  }
}

export function toFormData(object = {}) {

  const form = new FormData();

  try {
    Object.keys(object).map((objectKey) => {



      let pushFinally = true;
      let value = object[objectKey];


      if (objectKey === "remind_at") {
        value = value.toISOString();
      } else if (value instanceof File) {

        form.append(objectKey, value);
        pushFinally = false;
      } else if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          if (typeof value[i] === "object" && value[i] !== null) {
            Object.keys(value[i]).map((obKey, index) => {
              let v = value[i][obKey];
              form.append(`${objectKey}[${i}][${obKey}]`, v);
            });
          }
          else {
            form.append(`${objectKey}[]`, value[i]);
          }
        }

        pushFinally = false;
      } else if (typeof value === "object" && value !== null) {
        Object.keys(value).map((obKey, index) => {
          let v = value[obKey];
          form.append(`${objectKey}[${obKey}]`, v);
        });

        pushFinally = false;
      }

      if (pushFinally === true) {

        form.append(objectKey, value == null ? '' : value);
      }


    });
  } catch (error) {
    console.log(error);
  }

  return form;
}

export function logger(axios, data = {}) {
  try {
    axios.post("logs", data).catch(() => { });
  } catch (error) {

  }
}

export function profile(app) {
  app.$http
    .post("auth")
    .then((response) => {
      let data = response.data.data;
      app.$store.dispatch("setUser", data);
      app.$store.dispatch("setRoutes", data.sections);

      try {
        app.$socket.on(
          `retailbox_database_private-ticket:${data.id}`,
          (msg) => {
            if (data.id != msg.user_id) {

              app.$store.state.audio.play();

              app.$notify({
                title: `Ответ по тикету # ${msg.ticket_id} - ${msg.ticketMessage.ticket.name}`,
                message: `${msg.ticketMessage.description}`,
                icon: "ti-user",
                horizontalAlign: "left",
                verticalAlign: "bottom",
              });
              setTimeout(() => {
                app.$store.dispatch('setTicket', msg);
              }, 100);

            }
          }
        );
      } catch (error) { }

    })
    .catch((error) => {
      app.$store.dispatch("setUser", null);
    })
    .finally(() => {
      app.inital = true;
      setTimeout(() => {
        app.$loading(false);
      }, 400);
    });
}

export async function system() {

  this.$loading(true);

  try {
    const text = await this.$http.get('text');
    await this.$store.dispatch('setText', text.data);
  } catch (error) {
    // window.location.reload(true);
  }

  this.$store.dispatch('setHost', process.env.URL_MAIN);

  profile(this);

}

export function cardContent(model = "", id = "", params = {}) {
  this.$loading(true);
  return this.$http
    .get(`${model}${id ? `/${id}` : ""}`, {
      params: {
        ...params,
      },
    })
    .then((response) => {
      return multiKeyInit(response.data.data, this);
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function cardUpdate(
  model = "",
  item = {},
  fields = {},
  method = "PUT",
  child = false
) {
  this.$loading(true);

  const bodyFormData = new FormData();

  bodyFormData.append("_method", method);

  let val = null;

  fields.forEach((i) => {

 

    if (!i.isMultiLang && item.hasOwnProperty(i.key)) {



      let key = i.key;
      if (item[key] || item[key] == 0 || item[key] === null) {
        let value = item[key];
        if (Array.isArray(value)) {
          for (let j = 0; j < value.length; j++) {
            if (
              key === "new_images" &&
              value[j].file &&
              typeof value[j].file.name === "string"
            ) {
              bodyFormData.append(`images[${j}]`, value[j].file);
            } else if (key === "tags") {
              bodyFormData.append(`${key}[${j}]`, value[j].name);
            } else if (value[j] && value[j].id) {
              bodyFormData.append(`${key}[${j}]`, value[j].id);
            }
          }
          key = null;
        } else if (i.type === "select" || i.type === "selects" || i.type === "select-full" || i.type === "selects-full") {
          val = value && value["id"] ? value["id"] : null;
          key = `${key}_id`;
        } else if (key === "coords") {
          bodyFormData.append(`lat`, value.lat);
          bodyFormData.append(`lon`, value.lon);
        } else if (i.type === "object" && i.subFields) {
          key = `json_[${[i.key]}]`;
          val = item[i.key] ? JSON.stringify(item[i.key]) : null;
        } else {
          val = value;
        }
      }

      //ADDITIONAL
      if (val === true || val === "true") {
        val = 1;
      } else if (val === false || val === "false") {

        val = 0;
      } else if (val === "null") {
        val = "";
      } else if (val === null) {
        val = "";
      }

      bodyFormData.append(key, val);
    }
  });


  let route = child === true ? model : `${model}${item.id ? `/${item.id}` : ""} `;

  return this.$http({
    url: route,
    method: "POST",
    data: bodyFormData,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      "api-version": "1",
      platform: "web",
    },
  })
    .then((response) => {
      this.$store.dispatch("setLastUpdate", new Date());
      this.$notify({
        title: this.$store.state.text["success_notify"],
        message: this.$store.state.text["success_notify_saved"],
        icon: "ti-save",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });

      return response.data.data;
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
      return null;
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function multiKeysInit(items = [], app) {
  if (app.fields && app.fields.length) {
    if (items.length) {
      for (let i = 0; i < items.length; i++) {
        items[i] = multiKeyInit(items[i], app, i);
      }
    } else {
      multiKeyInit({}, app, 0);
    }
  }
  return items;
}

export function multiKeyInit(item = {}, app, count = 0) {
  if (app.fields && app.fields.length) {
    Object.keys(app.$store.state.languages).forEach((lang) => {
      let translationObject = {};
      if (item.translations) {
        translationObject = item.translations.find((obj) => {
          return obj.locale === lang;
        });
      }
      Object.keys(app.fields).forEach((key) => {
        let type = null;

        if (
          app.fields[key].type === "field" ||
          app.fields[key].type === "textarea"
        ) {
          type = "";
        } else if (app.fields[key].type === "checkbox") {
          type = false;
        } else if (app.fields[key].type === "selects") {
          type = [];
        } else if (app.fields[key].type === "tag") {
          type = [];
        } else if (app.fields[key].type === "select") {
          type = null;
        } else if (app.fields[key].type === "html") {
          type = "";
        } else if (app.fields[key].type === "object") {
          if (app.fields[key].subFields && app.fields[key].subFields.length) {
            type = {};
            for (let i = 0; i < app.fields[key].subFields.length; i++) {
              type[app.fields[key].subFields[i].key] = null;
            }
          }
        }
        if (app.fields[key].isMultiLang === true) {
          if (count === 0) {
            app.fields.push({
              key: app.fields[key].key + ":" + lang + "",
              label: app.fields[key].label,
              labelLang: app.$store.state.languages[lang],
              type: app.fields[key].type,
              col: app.fields[key].col ? app.fields[key].col : "",
              textType: app.fields[key].textType,
              langKey: lang,
            });
          }
          item[app.fields[key].key + ":" + lang + ""] =
            translationObject && translationObject[app.fields[key].key]
              ? translationObject[app.fields[key].key]
              : type;

          delete item[app.fields[key].key];
          // delete app.fields[key];
        } else if (!item[app.fields[key].key]) {
          item[app.fields[key].key] = type;
        }
      });
    });
  }
  return item;
}

export function moveIndex(arr, old_index, new_index) {
  while (old_index < 0) {
    old_index += arr.length;
  }
  while (new_index < 0) {
    new_index += arr.length;
  }
  if (new_index >= arr.length) {
    var k = new_index - arr.length;
    while (k-- + 1) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);

  return arr;
}

export function pushLang() {
  let languages = this.$store.state.languages;
  let langs = [];
  for (let i = 0; i < Object.keys(languages).length; i++) {
    langs.push({
      id: Object.keys(languages)[i],
      title: languages[Object.keys(languages)[i]],
    });
  }
  this.fields.unshift({
    label: "Язык всего элемента",
    key: "language_code",
    type: "static_radio",
    items: langs,
  });
}

export async function sha512(str) {
  const hash = await crypto.subtle
    .digest("SHA-512", new TextEncoder("utf-8").encode(str))
    .then((buf) => {
      return Array.prototype.map
        .call(new Uint8Array(buf), (x) => ("00" + x.toString(16)).slice(-2))
        .join("");
    });

  return hash;
}

export function dateConvert(dateString) {
  try {
    const dateParts = dateString.split('-');
    return dateParts[2] + '.' + dateParts[1] + '.' + dateParts[0];
  } catch (error) {
    return "";
  }
}

export function addMonth(date, month) {
  let newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() + month);
  return newDate.toISOString().slice(0, 10);
}